import { render } from "./PrizesStacked.vue?vue&type=template&id=2cc29234&scoped=true"
import script from "./PrizesStacked.vue?vue&type=script&lang=js"
export * from "./PrizesStacked.vue?vue&type=script&lang=js"

import "./PrizesStacked.vue?vue&type=style&index=0&id=2cc29234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc29234"]])

export default __exports__